/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetPipeSeriesStatus200, GetPipeSeriesStatus401 } from '../types/GetPipeSeries'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getPipeSeries } from '../clients/getPipeSeries'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getPipeSeriesQueryKey = () => [{ url: '/pipe-series/' }] as const

type GetPipeSeriesQueryKey = ReturnType<typeof getPipeSeriesQueryKey>

export function getPipeSeriesQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getPipeSeriesQueryKey()
  return queryOptions<GetPipeSeriesStatus200, ResponseErrorConfig<GetPipeSeriesStatus401>, GetPipeSeriesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getPipeSeries({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /pipe-series/}
 */
export function useGetPipeSeries<TData = GetPipeSeriesStatus200, TQueryData = GetPipeSeriesStatus200, TQueryKey extends QueryKey = GetPipeSeriesQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetPipeSeriesStatus200, ResponseErrorConfig<GetPipeSeriesStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getPipeSeriesQueryKey()

  const queryResult = useQuery({
   ...getPipeSeriesQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetPipeSeriesStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
